import { numberToUSDCurrencyStringValue } from '../../../../../models/utils/numberUtils';

// Blank and 0 are different: unset takes the server's floor (excludes $0.00 jobs), 0 admits everything.

export interface IParsedMinimumTotal {
	valid: boolean;
	value?: number;
}

/** parseMinimumTotalInput strips the `$` and `,` this emits, so the field round-trips on the next blur. */
export const formatMinimumTotalInput = (value?: number): string =>
	value == null ? '' : numberToUSDCurrencyStringValue(value);

export const parseMinimumTotalInput = (raw: string): IParsedMinimumTotal => {
	const trimmed = (raw ?? '').trim().replace(/[$,]/g, '');
	if (!trimmed) {
		return { valid: true, value: undefined };
	}

	const parsed = Number(trimmed);
	if (!Number.isFinite(parsed) || parsed < 0) {
		return { valid: false };
	}

	return { valid: true, value: Math.round(parsed * 100) / 100 };
};
